import {PlayerComponentHookType} from "../../components/wrappers/PlayerComponentWrapper";
import TechDecorator from "./TechDecorator";
import SkyClickPlayer from "../../components/custom/SkyClickPlayer";
import PlaylistPluginDecorator from "../../plugins/decorators/PlaylistPluginDecorator";
import {PlaylistEventType} from "../../plugins/decorators/PlaylistPluginDecorator";


export default class YouTubeDecorator extends TechDecorator{

    static readonly TECH_NAME = 'Youtube';

    static bootingStaticApi() {
        super.bootingStaticApi();
        this.hookManagerInstance.add<PlayerComponentHookType>('BEFORE_SETUP', (videoEl: Element, options: any) => {
            return this.processOptions(options);
        });
    }

    static processOptions(options: any) {

        options.playlist.forEach(function(playlistItem:any){
            // TODO check also for "youtu.be"
            if(playlistItem.sources[0].src.indexOf('youtube.com') !== -1){
                playlistItem.sources[0].type='video/youtube';
                options.techOrder = ['youtube',...SkyClickPlayer.getDefaultTechOrder()];

                // Load "YouTube" tech only, when youtube ressources are detected.
                // Prevent unused loading that could cause proxy authentications in protected networks.
                require('videojs-youtube/dist/Youtube.js');
                return false;
            }
        });

        return options;
    }

    protected playlistPluginDecorator: PlaylistPluginDecorator;

    public bootingExecution(){
        this.playlistPluginDecorator = this.skyClickPlayer.pluginManager.getPluginDecorator<PlaylistPluginDecorator>(PlaylistPluginDecorator.PLUGIN_NAME);

        // add item change listener
        this.eventManager.addListener<PlaylistEventType>('PLAYLIST_ITEM_CHANGE', this.onPlaylistChange.bind(this));

        // run item change lister at startup
        this.onPlaylistChange(null, this.playlistPluginDecorator.getCurrentItem());
    }


    protected onPlaylistChange(event:any, currentItem:any) {
        // Init resolution switcher, when "Youtube" tech is activated
        if(this.skyClickPlayer.techName_ == YouTubeDecorator.TECH_NAME){
            this.skyClickPlayer.tech_.ready(() => {
                // wait with resolution switcher init, until "Youtube" tech is ready
                this.skyClickPlayer.initResolutionForYt(this.skyClickPlayer);
            })
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/tech/decorators/YouTubeDecorator.ts